var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mailvelope)?_c('div',{attrs:{"id":"mail-content"}},[_c('MdnRequest',{attrs:{"message":_vm.message}})],1):_c('span',[_vm._v(_vm._s(_vm.t('mail', 'This message is encrypted with PGP. Install Mailvelope to decrypt it.')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }